import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { GruposLiquidacion } from '../models/gruposLiquidacion';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/GruposLiquidacion';

@Injectable({
  providedIn: 'root'
})
export class GruposLiquidacionService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getById(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/Index?id=' + code })
  }

  save(gruposLiquidacion, cambioEstado): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cambioEstado, body: gruposLiquidacion, cacheMins: 0 });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  GetVigenteByPersonal(personal: number)
  {
    return this._http.get<any>({ url: baseUrl + '/GetVigenteByPersonal?personal=' + personal });
  }
}

